<div class="main-container centerWithFlex">

    <div class="inner-container">
          <div class="dottedBorder" style="height: 10%;width: 100%;display: flex;
          border-bottom: solid 1px #bebebe;">
                 <div class="dottedBorder" style="width: 2%;height: 100%;">
                       
                 </div>
                 <div class="dottedBorder" style="width: 75%;height: 100%;font-weight:700;
                 display: flex;align-items: center;">
                      Jobs
                 </div>
                 <div class="dottedBorder centerWithFlex" style="width: 20%;height: 100%;">
                        <button class="AddFeedButton" (click)="addJobOpening()" >Add Job Opening</button>
                 </div>
          </div>

          
          <div class="dottedBorder" style="height: 75%;width: 100%;">
            <div style="height: 10%;width: 100%;"></div>
            <div  style="height: 90%;width: 100%;overflow-y: scroll;">
              <mat-table class="dottedBorder" style="border-top: solid 1px #e9e9e9;width: 100%;font-family: roboto;font-size: 12px;" #table [dataSource]="dataSource">
   
    
                  <ng-container matColumnDef="category">
                    <mat-header-cell *matHeaderCellDef style="width:10% !important; flex: 0 0 10% !important;"class="listHeaderStyle">Category  </mat-header-cell>
                    <mat-cell *matCellDef="let element" style="width:10% !important; flex: 0 0 10% !important;"> {{element.category}} </mat-cell>
                  </ng-container>
              
                  <ng-container matColumnDef="domain">
                    <mat-header-cell *matHeaderCellDef style="width:10% !important; flex: 0 0 10% !important;"class="listHeaderStyle"> Job Role</mat-header-cell>
                    <mat-cell *matCellDef="let element" style="width:10% !important; flex: 0 0 10% !important;"> {{element.domain}} </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="location">
                    <mat-header-cell *matHeaderCellDef style="width:10% !important; flex: 0 0 10% !important;"class="listHeaderStyle"> Location </mat-header-cell>
                    <mat-cell *matCellDef="let element" style="width:10% !important; flex: 0 0 10% !important;"> {{element.location}} </mat-cell>
                  </ng-container>
              
                  <ng-container matColumnDef="employer">
                    <mat-header-cell *matHeaderCellDef style="width:10% !important; flex: 0 0 10% !important;"class="listHeaderStyle"> Employer </mat-header-cell>
                    <mat-cell *matCellDef="let element" style="width:10% !important; flex: 0 0 10% !important;"> {{element.employer}} </mat-cell>
                  </ng-container>
            
                  <ng-container matColumnDef="link">
                      <mat-header-cell *matHeaderCellDef style="width:10% !important; flex: 0 0 20% !important;"class="listHeaderStyle">Job Link </mat-header-cell>
                      <mat-cell *matCellDef="let element" style="width:10% !important; flex: 0 0 20% !important;">        
                          <a style="color: black;" target="_blank" href="{{element.link}}">{{element.link}}</a>
                      </mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="description">
                    <mat-header-cell *matHeaderCellDef style="width:10% !important; flex: 0 0 20% !important;"class="listHeaderStyle"> Description </mat-header-cell>
                    <mat-cell *matCellDef="let element" style="width:10% !important; flex: 0 0 20% !important;"> {{element.description}} </mat-cell>
                  </ng-container>
                  
      
                  <ng-container matColumnDef="createdDate">
                      <mat-header-cell *matHeaderCellDef style="width:10% !important; flex: 0 0 12% !important;"class="listHeaderStyle"> Created Date </mat-header-cell>
                      <mat-cell *matCellDef="let element" style="width:10% !important; flex: 0 0 12% !important;"> 
                          {{element.createdDate | date:'dd/MM/yyyy  hh.mm aa'}}
                       </mat-cell>
                  </ng-container>
      
                  <ng-container matColumnDef="action">
                      <mat-header-cell *matHeaderCellDef style="width:10% !important; flex: 0 0 10% !important;"class="listHeaderStyle" > Action </mat-header-cell>
                      <mat-cell *matCellDef="let element" style="width:10% !important; flex: 0 0 10% !important;"> 
                        <mat-icon style="font-size: 20px;" matTooltip="Edit" (click)="editJob(element.id)">edit</mat-icon>
                        <mat-icon style="margin-left: 5px;font-size: 20px;" matTooltip="Delete" (click)="deleteJob(element.id)" >delete_outline</mat-icon>
                     </mat-cell>
                  </ng-container>
            
              
                  <mat-header-row style="width: 100%;" class="listGridHeaderRowStyle" *matHeaderRowDef="displayColumns; sticky:true"></mat-header-row>
                  <mat-row style="width: 100%;" *matRowDef="let row; columns: displayColumns;"></mat-row>
              </mat-table>
            </div>
            </div>








          <!-- <div class="dottedBorder" style="height: 75%;width: 100%;">
            <div style="height: 10%;width: 100%;"></div>
            <div  style="height: 90%;width: 100%;overflow-y: scroll;">
                <table style="height: 100%;width: 100%;" class="variable-rows">

                    <colgroup>
                        <col span="1" style="width: 12%;">
                        <col span="1" style="width: 12%;">
                        <col span="1" style="width: 15%;">
                        <col span="1" style="width: 15% !important;max-width: 18% !important;">
                        <col span="1" style="width: 21%;">
                        <col span="1" style="width: 15%;">
                        <col span="1" style="width: 10%;">
                     </colgroup>
                <thead >  
                    <tr style="height: 36px;width: 100%;">
                        <th class="cut-text" style="border-left: 0px !important;">Category</th>
                        <th class="cut-text" >Domain</th>
                        <th class="cut-text" >Location</th>
                        <th class="cut-text" >Employer</th>
                        <th class="cut-text" >Link</th>
                        <th class="cut-text" >Description</th>
                        <th  class="cut-text">Created Date</th>
                        <th class="cut-text" style="border-right: 0px !important;">Actions</th>
                    </tr>
                </thead> 
                <tbody>     
                        <tr *ngFor="let job of dataSource">
                            <td class="cut-text" style="border-left: 0px !important;">{{job.category}}</td>
                            <td class="cut-text">{{job.domain}}</td>
                            <td class="cut-text">{{job.location}}</td>
                            <td class="cut-text">{{job.employer}}</td>
                            <td class="cut-text">
                                <a style="color: black;" target="_blank" href="{{job.link}}">{{job.link}}</a>
                            </td>
                            <td class="cut-text">{{job.description}}</td>
                            <td class="cut-text">{{job.createdDate | date:'dd/MM/yyyy  hh.mm aa'}}</td>
                            <td style="border-right: 0px !important;">
                                <mat-icon style="margin-left: 5px;font-size: 20px;" matTooltip="Edit" (click)="editJob(job.id)">edit</mat-icon>
                                <mat-icon style="margin-left: 5px;font-size: 20px;" matTooltip="Delete" (click)="deleteJob(job.id)" >delete_outline</mat-icon>
                            </td>
                          </tr>
                </tbody>     
                </table>
            </div>
          

          </div> -->

          <div class="dottedBorder centerWithFlex" style="height: 15%;width: 100%;">
             <mat-paginator  [length]="total" (page)="getList($event)"
                    [pageSize]="100"
                    [pageSizeOptions]="[10, 25, 100]"
                    aria-label="Select page">
             </mat-paginator>

          </div>
    </div>

</div>